var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePauseAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4C5.44772 4 5 4.44772 5 5V15C5 15.5523 5.44772 16 6 16H8C8.55228 16 9 15.5523 9 15V5C9 4.44772 8.55228 4 8 4H6ZM12 4C11.4477 4 11 4.44772 11 5V15C11 15.5523 11.4477 16 12 16H14C14.5523 16 15 15.5523 15 15V5C15 4.44772 14.5523 4 14 4H12Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePauseAudioIcon);
export default __webpack_public_path__ + "static/media/active-pause-audio-icon.cfaf7a1d57d0c09e23a8b875a023c6a8.svg";
export { ForwardRef as ReactComponent };